import { render, staticRenderFns } from "./CurrencyRateList.vue?vue&type=template&id=81a5d398&scoped=true&"
import script from "./CurrencyRateList.vue?vue&type=script&lang=js&"
export * from "./CurrencyRateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a5d398",
  null
  
)

export default component.exports